import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/plugins/vue-i18n'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#686868',
        viralYellow: '#FBF000'
      },
      dark: {
        primary: '#686868',
        viralYellow: '#FBF000'
      }
    },
    options: {
      customProperties: true
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
